// extracted by mini-css-extract-plugin
module.exports = {"account-overview-content":"account-overview-content__3QbJP"};